import { CustomRoute } from "@router/types";
import authCodeMap from "@/dataBase/authCodeMap";
const routes: Array<CustomRoute> = [
  {
    path: "/login",
    name: authCodeMap.common_login,
    redirect: "/newCommunity/login",
    component: (): any => import("@/modules/common/pages/login/index.vue"),
    meta: {
      title: "爱问医生-千帆社区-登录",
      hidden: false,
      icon: "tree",
      authCode: authCodeMap.common_login,
    },
  },
  {
    path: "/newCommunity/login",
    name: authCodeMap.newCom_login,
    component: (): any => import("@/modules/newCommunity/pages/login/index.vue"),
    meta: {
      title: "爱问医生-千帆社区-登录",
      hidden: false,
      icon: "tree",
      authCode: authCodeMap.newCom_login,
      ignorePermission: true,
    },
  },
  {
    path: "/proxy/login",
    name: "proxyLogin",
    redirect: "/newCommunity/login",
    component: (): any => import("@/modules/common/pages/login/ProxyLoginPage.vue"),
    meta: {
      title: "爱问医生-千帆社区(内部)-登录",
      hidden: false,
      icon: "tree",
      authCode: authCodeMap.common_login,
    },
  },
  {
    path: "/medicine/home",
    redirect: "/home",
    meta: { title: "爱问医生-千帆社区" },
  },
  {
    path: "/create",
    redirect: "/newCommunity/login",
    name: authCodeMap.common_create,
    component: (): any => import("@/modules/common/pages/create/index.vue"),
    meta: {
      title: "爱问医生-千帆社区-免费注册",
      hidden: false,
      icon: "tree",
      authCode: authCodeMap.common_create,
    },
  },
  {
    path: "/create/new",
    name: "common_create_new",
    component: (): any => import("@/modules/common/pages/create/new.vue"),
    meta: {
      title: "爱问医生-千帆社区-免费注册",
      hidden: false,
      icon: "tree",
      authCode: "common_create_new",
      isNew: true,
    },
  },
  {
    path: "/proxy/create",
    redirect: "/newCommunity/login",
    name: "proxyCreate",
    component: (): any => import("@/modules/common/pages/create/ProxyRegisterPage.vue"),
    meta: {
      isProxy: true,
      title: "爱问医生-千帆社区(内部)-免费注册",
      hidden: false,
      icon: "tree",
      authCode: authCodeMap.common_create,
    },
  },
  {
    path: "/setRegisteredPass",
    name: "setRegisteredPass",
    component: (): any => import("@/modules/common/pages/create/setRegisteredPass.vue"),
    meta: {
      title: "爱问医生-千帆社区-设置密码",
      hidden: false,
      icon: "tree",
      authCode: "setRegisteredPass",
      isNew: true,
    },
  },
  {
    path: "/communityList",
    name: authCodeMap.community_list,
    component: (): any => import("@/modules/common/pages/community/community_list.vue"),
    meta: {
      title: "爱问医生-千帆社区-选择社区",
      hidden: false,
      icon: "tree",
      needLogin: true,
      authCode: authCodeMap.community_list,
    },
  },
  {
    path: "/newCommunity/communityList",
    name: authCodeMap.newCom_community_list,
    component: (): any => import("@/modules/newCommunity/pages/community/community_list.vue"),
    meta: {
      title: "爱问医生-千帆社区-选择社区",
      hidden: false,
      icon: "tree",
      needLogin: true,
      authCode: authCodeMap.newCom_community_list,
      isNew: true,
      ignorePermission: true,
    },
  },
  {
    // budgetTokenTrans

    path: "/newCommunity/budgetTokenTrans",
    name: authCodeMap.newCom_budgetTokenTrans,
    component: (): any => import("@/modules/newCommunity/pages/community/budgetTokenTrans.vue"),
    meta: {
      title: "爱问医生-千帆社区-选择",
      hidden: false,
      icon: "tree",
      needLogin: false,
      authCode: authCodeMap.newCom_budgetTokenTrans,
      isNew: true,
      ignorePermission: true,
    },
  },
  {
    path: "/callback",
    name: authCodeMap.callback,
    component: (): any => import("@/modules/common/pages/callback/index.vue"),
    meta: {
      title: "爱问医生-千帆社区-绑定中",
      hidden: false,
      icon: "tree",
      needLogin: false,
      authCode: authCodeMap.callback,
      ignorePermission: true,
    },
  },
  // {
  //   path: "/index",
  //   component: (): any => import("@/modules/common/pages/index/pages/index.vue"),
  //   meta: {
  //     title: "爱问医生-千帆社区-新浪健康旗下医疗SaaS平台",
  //     hidden: false,
  //     icon: "tree",
  //     needLogin: false,
  //   },
  // },
  {
    path: "/index",
    component: (): any => import("@/modules/common/pages/newIndex/index.vue"),
    meta: {
      title: "爱问医生-千帆社区-助您快速运营互联网医院搭建私域经营设施",
      hidden: false,
      icon: "tree",
      needLogin: false,
    },
  },
  {
    path: "/cooperation",
    component: (): any => import("@/modules/common/pages/newIndex/pages/cooperation.vue"),
    meta: {
      title: "爱问医生-千帆社区-助您快速运营互联网医院搭建私域经营设施-合作申请",
      hidden: false,
      icon: "tree",
      needLogin: false,
    },
  },
  {
    path: "/download",
    component: (): any => import("@/modules/common/pages/download/index.vue"),
    meta: {
      title: "爱问医生-千帆社区-新浪健康旗下医疗SaaS平台",
      hidden: false,
      icon: "tree",
      needLogin: false,
    },
  },
  {
    path: "/agreement",
    name: "Agreement",
    component: (): any => import("@/modules/common/pages/agreement/index.vue"),
    meta: {
      title: "爱问医生-千帆社区-用户注册协议",
      hidden: false,
      icon: "tree",
      needLogin: false,
    },
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: (): any => import("@/modules/common/pages/privacy/index.vue"),
    meta: {
      title: "爱问医生-千帆社区-法律声明及隐私权政策",
      hidden: false,
      icon: "tree",
      needLogin: false,
    },
  },
  {
    path: "/subscription",
    name: "Subscription",
    component: (): any => import("@/modules/common/pages/subscription/index.vue"),
    meta: {
      title: "爱问医生-千帆社区-订购协议",
      hidden: false,
      icon: "tree",
      needLogin: false,
    },
  },
  {
    path: "/userCenter",
    name: "userCenter",
    component: (): any => import("@/modules/common/pages/userCenter/userCenter.vue"),
    meta: {
      title: "爱问医生-千帆社区-个人资料",
      hidden: false,
      icon: "tree",
      needLogin: true,
    },
  },
  {
    path: "/accountSecurity",
    name: "accountSecurity",
    component: (): any => import("@/modules/common/pages/userCenter/newUserCenter.vue"),
    meta: {
      title: "爱问医生-千帆社区-账号安全",
      hidden: false,
      icon: "tree",
      needLogin: true,
      isNew: true,
      ignorePermission: true,
    },
  },
  {
    path: "/subscribe/clueManage",
    name: "subscribeClueManage",
    component: (): any => import("@/modules/common/pages/subscribe/clueManage/index.vue"),
    meta: {
      title: "爱问医生-千帆社区-线索管理（全量）",
      hidden: false,
      icon: "tree",
      needLogin: true,
    },
  },
  {
    path: "/subscribe/consumptionManagement",
    name: "subscribeConsumptionManagement",
    component: (): any => import("@/modules/common/pages/subscribe/consumptionManagement/index.vue"),
    meta: {
      title: "爱问医生-千帆社区-消费管理（全量）",
      hidden: false,
      icon: "tree",
      needLogin: true,
    },
  },
  {
    path: "/subscribe/goodsManage",
    name: "subscribeGoodsManage",
    component: (): any => import("@/modules/common/pages/subscribe/goodsManage/index.vue"),
    meta: {
      title: "爱问医生-千帆社区-商品管理（全量）",
      hidden: false,
      icon: "tree",
      needLogin: true,
    },
  },
  {
    path: "/subscribe/shopManage",
    name: "subscribeShopManage",
    component: (): any => import("@/modules/common/pages/subscribe/shopManage/index.vue"),
    meta: {
      title: "爱问医生-千帆社区-零售商管理（全量）",
      hidden: false,
      icon: "tree",
      needLogin: true,
    },
  },
  {
    path: "/bMember",
    name: "bMember",
    component: (): any => import("@/modules/common/pages/bMember/bMember.vue"),
    meta: {
      title: "爱问医生-千帆社区-成员管理",
      hidden: false,
      icon: "tree",
      needLogin: true,
    },
  },
  {
    path: "/bSetting",
    name: "bSetting",
    component: (): any => import("@/modules/common/pages/bSetting/bSetting.vue"),
    meta: {
      title: "爱问医生-千帆社区-机构设置",
      hidden: false,
      icon: "tree",
      needLogin: true,
    },
  },
  {
    path: "/forget",
    name: "forget",
    component: (): any => import("@/modules/common/pages/forget/forget.vue"),
    meta: {
      title: "爱问医生-千帆社区-忘记密码",
      hidden: false,
      icon: "tree",
      needLogin: false,
    },
  },
  {
    path: "/newForget",
    name: "newForget",
    component: (): any => import("@/modules/common/pages/forget/newForget.vue"),
    meta: {
      title: "爱问医生-千帆社区-新修改密码",
      hidden: false,
      icon: "tree",
      needLogin: false,
      isNew: false,
    },
  },
  {
    path: "/invite",
    name: "invite",
    component: (): any => import("@/modules/common/pages/invite/index.vue"),
    meta: {
      title: "爱问医生-千帆社区-邀请加入社区",
      hidden: false,
      icon: "tree",
      needLogin: false,
    },
  },
  {
    path: "/community_register",
    name: "community_register",
    component: (): any => import("@/modules/common/pages/communityRegister/communityRegister.vue"),
    meta: {
      title: "爱问医生-千帆社区-新建社区",
      hidden: false,
      needLogin: true,
    },
  },
  {
    path: "/helpcenter",
    name: authCodeMap.newCom_helpcenter,
    component: (): any => import("@/modules/common/pages/helpCenter/index.vue"),
    meta: {
      title: "帮助中心",
      hidden: false,
      icon: "tree",
      needLogin: false,
      authCode: authCodeMap.newCom_helpcenter,
      isNew: true,
    },
  },
];
export default routes;
